import { render } from "./HomeMiddleButton.vue?vue&type=template&id=7ca0e7e4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__